import { render, staticRenderFns } from "./formulario.vue?vue&type=template&id=60a51630"
import script from "./formulario.vue?vue&type=script&lang=ts"
export * from "./formulario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports